import React from "react"
import { CurrConvertPrice } from "../CurrencyConverter/CurrConvertPrice"

const CurrencyPrice = ({ price }) => {
  return <>{CurrConvertPrice(price?.toLocaleString())}</>
}

export default CurrencyPrice
